import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "_mt-1 _flex _ai-c _gap-2" }
const _hoisted_2 = ["href"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_floating_message = _resolveComponent("floating-message")

  return (_ctx.isVisible)
    ? (_openBlock(), _createBlock(_component_floating_message, _mergeProps({ key: 0 }, $options.floatingMessageConfig, {
        "data-qa": `cookie-policy-box:${_ctx.isVisible}`
      }), {
        icon: _withCtx(() => [
          _createVNode(_component_base_icon, {
            name: "cookie-icon",
            size: "lg",
            class: "_tc--info",
            "icon-namespace": "ga",
            "has-base-class": ""
          })
        ]),
        actions: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("button", {
              type: "button",
              class: "gfu-btn gfu-btn--primary gfu-btn--soft gfu-btn--micro _ttu",
              onClick: _cache[0] || (_cache[0] = (...args) => ($options.acceptAll && $options.acceptAll(...args))),
              "data-qa": "cookie-policy-button:AcceptAll"
            }, _toDisplayString(_ctx.Resources.Common.ModalOkButton), 1 /* TEXT */),
            _createElementVNode("a", {
              class: "gfu-link gfu-link--primary _fw-b _ttl",
              href: $props.privacySettingsUrl,
              "data-qa": "cookie-policy-button:CookieSettings"
            }, _toDisplayString(_ctx.Resources.Cookies.PageHeader), 9 /* TEXT, PROPS */, _hoisted_2)
          ])
        ]),
        _: 1 /* STABLE */
      }, 16 /* FULL_PROPS */, ["data-qa"]))
    : _createCommentVNode("v-if", true)
}